/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import _, { filter } from 'lodash';
import { toast } from 'react-toastify';
import { getDepartment } from '../../../api/medRepApi';
import { getProductList } from '../../../api/productSamplingMaintenanceAPI';
import useProductSamplingContext from '../context/useProductSamplingContext';

function Filter() {
  const { auth, setFilterForm, filterForm, searchProductList, clearProductList } =
    useContext(useProductSamplingContext);

  const [departmentOptions, setDepartMent] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  const loadDepartmentDropdown = async () => {
    try {
      let departmentDropdown;
      const res = await getDepartment();
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row) => ({
          value: row,
          label: row,
        }));

        if (data.length === 1) {
          setFilterForm({ ...filterForm, department: dropdownValue[0] });
          departmentDropdown = dropdownValue;
        } else {
          departmentDropdown = [{ label: 'ALL', value: null }, ...dropdownValue];
        }
        setDepartMent(departmentDropdown);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadProductstDropdown = async () => {
    try {
      const request = {
        department: filterForm?.department?.value,
        product_code: [],
      };
      const res = await getProductList(request);
      const { code, data } = res.data;

      if (code === '200') {
        setProductOptions(
          data?.map((row) => ({
            value: row.product_code,
            label: row.product_name,
          })),
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleProductChange = (newValue) => {
    setProductOptions(newValue ? [newValue, ...productOptions] : productOptions);
    setFilterForm({ ...filterForm, products: newValue });
  };
  useEffect(() => {
    loadDepartmentDropdown();
    loadProductstDropdown();
  }, [filterForm]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='department'
            disableClearable
            fullWidth
            options={departmentOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Deparment' />}
            size='small'
            value={filterForm?.department}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>
        <Grid md={4}>
          <Autocomplete
            disablePortal
            id='products'
            disableClearable
            multiple
            fullWidth
            options={productOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            autoComplete
            includeInputInList
            filterSelectedOptions
            getOptionLabel={(option) => (option.label ? option.label : '')}
            value={filterForm.products ?? []}
            noOptionsText='No Products'
            onChange={(event, newValue) => handleProductChange(newValue)}
            isOptionEqualToValue={(option, selected) => option.value === selected.value}
            renderInput={(params) => <TextField {...params} label='Products' fullWidth />}
            renderOption={(props, option) => (
              <li {...props} key={option.value}>
                {option.label}
              </li>
            )}
            size='small'
          />
        </Grid>

        <Grid md={4}>
          <Button variant='contained' color='success' onClick={searchProductList}>
            Generate
          </Button>

          <Button
            variant='contained'
            color='primary'
            onClick={clearProductList}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Filter;
